import { Content } from "containers/RightPanel/RightPanel.styles";
import KbArticle from "components/KbArticle";
import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

export const Title = styled.span`
  margin-left: 10px;
`;

export const HelpContent = Content;

export const Spinner = styled(PreLoader)`
  position: absolute;
  margin-top: 80px;
`;

export const Answer = styled(KbArticle)`
  width: 100%;
`;
